<template>
  <el-row>
    <el-col
      :xs="{ span: 22, offset: 1 }"
      :sm="{ span: 22, offset: 1 }"
      :md="{ span: 20, offset: 2 }"
      :lg="{ span: 16, offset: 4 }"
      :xl="{ span: 16, offset: 4 }"
    >
      <el-card class="content">
        <h3 class="head-title" style="margin-bottom: 10px">
          {{ $t("fullSearch.title") }}
        </h3>
        <div style="width: 90%; margin: 0 auto">
          <div style="margin-bottom: 30px">
            <p style="margin-bottom: 5px">
              <i class="el-icon-edit"></i>{{ $t("fullSearch.p1") }}
            </p>

            <el-select
              v-model="value1"
              :placeholder="$t('fullSearch.select')"
              size="medium"
              style="margin-right: 5px"
            >
              <el-option
                v-for="item in options"
                :key="item.potentialId"
                :label="item.potentialName"
                :value="item.potentialName"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="value2"
              :placeholder="$t('fullSearch.select')"
              size="medium"
            >
              <el-option
                v-for="item in options"
                :key="item.potentialId"
                :label="item.potentialName"
                :value="item.potentialName"
              >
              </el-option>
            </el-select>
            <div class="button-group" style="float: right">
              <span @click="addRel">
                <button-secondary class="btn1">
                  <i class="el-icon-plus">&nbsp;{{ $t("setting.add") }}</i>
                </button-secondary>
              </span>
              <span @click="delRel">
                <button-secondary class="btn2">
                  <i class="el-icon-close">&nbsp;{{ $t("setting.del") }}</i>
                </button-secondary>
              </span>
            </div>
          </div>
          <div>
            <p><i class="el-icon-finished"></i>{{ $t("fullSearch.p2") }}</p>
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column :label="$t('fullSearch.cause')" prop="v1">
                <template slot-scope="scope">
                  <el-tag effect="dark" size="mini" class="v1">{{
                    scope.row.v1
                  }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column :label="$t('fullSearch.effect')" prop="v2">
                <template slot-scope="scope">
                  <el-tag effect="dark" size="mini" class="v2">{{
                    scope.row.v2
                  }}</el-tag>
                </template>
              </el-table-column>
            </el-table>
            <div class="button-group" style="margin: 10px 0; text-align: right">
              <span @click="goBack">
                <button-secondary class="btn1">
                  <i class="el-icon-arrow-left"
                    >&nbsp;{{ $t("fullSearch.back") }}</i
                  >
                </button-secondary>
              </span>
              <span @click="searchFullIds">
                <button-primary class="btn2">
                  <i class="el-icon-search"
                    >&nbsp;{{ $t("fullSearch.search") }}</i
                  >
                </button-primary>
              </span>
            </div>
          </div>
          <div class="result" v-show="this.showResult">
            <p><i class="el-icon-finished"></i>{{ $t("fullSearch.p3") }}</p>
            <div class="full-result-list-container">
              <ul class="full-result-list">
                <li v-for="item in results" :key="item.modelId" class="li">
                  <el-col
                    class="full-pics"
                    @click.native="toOptimalResult(item.modelId)"
                    :span="8"
                  >
                    <img
                      class="result-pic"
                      :src="getUrlPic(item.resultPic)"
                      :alt="$t('full.pic')"
                    />
                  </el-col>
                </li>
                <div style="clear: both"></div>
              </ul>
            </div>
          </div>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { getPotentialsApi, searchFullIdsApi } from "network/project";
import ButtonSecondary from "components/body/ButtonSecondary";
import ButtonPrimary from "components/body/ButtonPrimary";
export default {
  name: "FullSearch",
  data() {
    return {
      value1: "", //因
      value2: "", //果
      multipleSelection: [], //选择的项
      options: [], //潜在变量选项
      tableData: [], //已添加的潜在变量因果关系列表
      showResult: false, //是否显示搜索结果
      results: [], //搜索结果
    };
  },
  created() {
    getPotentialsApi()
      .then((res) => {
        if (res.success) {
          this.options = res.data;
          this.value1 = this.options[0].potentialName;
          this.value2 = this.options[0].potentialName;
        } else {
          console.log(res.errorInfo);
          this.$message.error(this.$t("fullSearch.err1"));
        }
      })
      .catch((err) => {
        this.$message.error(this.$t("fullSearch.err1"));
      });
  },
  methods: {
    //返回
    goBack() {
      this.$router.push("/full/result");
    },
    //搜索全模型结果
    searchFullIds() {
      this.calcRelation();
      if (this.tableData.length == 0) {
        this.$message.error(this.$t("fullSearch.err2"));
        return;
      }
      if (this.multipleSelection.length == 0) {
        this.$message.error(this.$t("fullSearch.err9"));
        this.showResult = false;
        this.results = [];
        return;
      }
      let relation = this.calcRelation();
      searchFullIdsApi(relation)
        .then((res) => {
          if (res.success) {
            if (res.data.length > 0) {
              this.showResult = true;
              this.results = res.data;
            } else {
              this.$message.info(this.$t("fullSearch.noData"));
            }
          } else {
            console.error(res.errorInfo);
            this.$message.error(this.$t("fullSearch.err3"));
          }
        })
        .catch((err) => {
          this.$message.error(this.$t("fullSearch.err3"));
        });
    },
    //跳转至最有全模型分析结果
    toOptimalResult(id) {
      this.$router.push({
        path: "/full/detail",
        query: {
          id: id,
        },
      });
    },
    //增加关系项
    addRel() {
      if (this.value1 == "" || this.value2 == "") {
        this.$message.error(this.$t("fullSearch.err4"));
        return;
      }
      if (this.value1 == this.value2) {
        this.$message.error(this.$t("fullSearch.err5"));
        return;
      }
      var item = {
        v1: this.value1,
        v2: this.value2,
      };
      if (
        this.tableData.filter((i) => {
          return i.v1 == item.v1 && i.v2 == item.v2;
        }).length != 0
      ) {
        this.$message.error(this.$t("fullSearch.err6"));
        return;
      }
      if (
        this.tableData.filter((i) => {
          return i.v1 == item.v2 && i.v2 == item.v1;
        }).length != 0
      ) {
        this.$message.error(this.$t("fullSearch.err8"));
        return;
      }
      this.tableData.push(item);
    },
    //删除关系项
    delRel() {
      let len = this.multipleSelection.length;
      if (len === 0) {
        this.$message.error(this.$t("fullSearch.err7"));
      }
      for (let i = 0; i < len; i++) {
        let index = this.tableData.indexOf(this.multipleSelection[i]);
        this.tableData.splice(index, 1);
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 计算relation
    calcRelation() {
      let potentials = [];
      this.options.forEach((item) => potentials.push(item.potentialName));
      // let arr0_index = new Array();
      // let arr1_index = new Array();
      // let potential_length = potentials.length;
      // if(this.multipleSelection.length==0) {
      //   this.$message.error("请至少勾选一个选择的关系");
      //   return;
      //   }
      // let count = 0;
      // this.multipleSelection.forEach(item => {
      //   count++;
      //   for (let i = 0; i < potential_length; i++) {
      //     if (potentials[i] == item.v1) arr0_index.push(i);
      //     else if (potentials[i] == item.v2) arr1_index.push(i);
      //   }
      // })
      // if (count == 0) this.$message.warning(this.$t('fullSearch.err2'))
      // else {
      //   let s = new Array();
      //   let s_length = potential_length * (potential_length - 1) / 2;
      //   for (let i = 0; i < s_length; i++) s[i] = 0;
      //   for (let i = 0; i < potential_length; i++) {
      //     let first = arr0_index[i];
      //     let second = arr1_index[i];
      //     let index = 0;
      //     let over = false;
      //     if (first < second) {
      //       for (let j = 0; j < s_length - 1; j++) {
      //         for (let k = j + 1; k < s_length; k++) {
      //           if (first == j && second == k) {
      //             over = true;
      //             break;
      //           }
      //           index++;
      //         }
      //         if (over) break;
      //       }
      //       if (index < s_length) s[index] = 1;
      //     } else {
      //       for (let j = 0; j < s_length - 1; j++) {
      //         for (let k = j + 1; k < s_length; k++) {
      //           if (first == k && second == j) {
      //             over = true;
      //             break;
      //           }
      //           index++;
      //         }
      //         if (over) break;
      //       }
      //       if (index < s_length) s[index] = 2;
      //     }
      //   }
      //   let result = "";
      //   for (let i = 0; i < s_length; i++) result += s[i];
      //   return result;
      // }
      let relationMatrix = [];
      let relationString = "";
      // 初始化二维数组
      for (let i = 0; i < potentials.length; ++i) {
        relationMatrix.push(new Array(potentials.length));
        for (let j = 0; j < potentials.length; ++j) {
          relationMatrix[i][j] = 0;
        }
      }
      // 筛选符合并更新符合条件的数据
      for (const obj of this.multipleSelection) {
        const impactPotential = potentials.findIndex((v) => v === obj.v1);
        const impactedPotential = potentials.findIndex((v) => v === obj.v2);
        relationMatrix[impactPotential][impactedPotential] = 1;
      }
      relationMatrix.forEach((item) => {
        item.forEach((i) => {
          relationString += i;
        });
      });
      return relationString;
    },
    getUrlPic(url) {
      return url.replace(
        "http://localhost:9000/autosem",
        "//autosem.net/download"
      );
    },
  },
  components: {
    ButtonSecondary,
    ButtonPrimary,
  },
};
</script>

<style>
.v1.el-tag--dark {
  background-color: #5cb85c;
  border-color: #5cb85c;
}

.v2.el-tag--dark {
  background-color: #5bc0de;
  border-color: #5bc0de;
}
</style>
<style scoped>
.button-group .btn1 {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}

.button-group .btn2 {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

.full-result-list-container {
  border: 2px solid #dedede;
  border-radius: 5px;
  padding-bottom: 0px;
  margin-bottom: 20px;
}

.full-pics {
  padding: 10px;
  height: 255px;
  border: 1px solid #dedede;
  -moz-border-radius: 8px;
  -webkit-border-radius: 8px;
  border-radius: 8px;
  float: left;
  margin-bottom: 10px;
  cursor: pointer;
  background-color: #ffffff;
}

.result-pic {
  width: 100%;
  height: 100%;
  object-fit: scale-down;
}
</style>
